<template>
  <main class="page-padding page-sidebar users-page">
    <data-table></data-table>
    <transition name="form-right">
      <user-info v-if="showInfo"></user-info>
    </transition>
  </main>
</template>


<script>
  import remBtn from "../components/Svg/remBtn";
  import dataTable from "../components/Pages/Users/dataTable";
  import {mapState,mapMutations,mapActions} from 'vuex'
  import {tokenAndRoute} from "../mixins/utils/tokenAndRoute";
  import userInfo from '../components/Pages/Users/userInfo'
  import {hideRoles} from "../mixins/roles/hideRoles";
  import {loaderMixin} from "../mixins/utils/loaderMixin";

  export default {
    name: 'usersPage',
    mixins: [tokenAndRoute, hideRoles, loaderMixin],
    components: {
      dataTable,
      remBtn,
      userInfo
    },
    data() {
      return {

      }
    },
    filters: {
      date: function (value) {
        if (!value) return ''
        value = new Date
        return value.charAt(0).toUpperCase() + value.slice(1)
      }
    },
    watch: {
      activeUser(val) {
        if (val === undefined) {
          this.setShowInfo(false)
        }
      }
    },
    computed: {
      ...mapState({
        showInfo: state => state.users.showInfo,
        activeUser: state => state.users.rightInfo
      }),
    },

    methods: {
      ...mapMutations({
        setFullSidebar: 'sidebar/SET_DASHBOARD',
        setLinkName: 'sidebar/SET_LINK_NAME',
        setRouteName: 'sidebar/SET_ROUTE_NAME',
        setRightInfo: 'users/SET_RIGHT_INFO',
        setShowInfo: 'users/SET_SHOW_INFO',
      }),
      ...mapActions({
        getInvitedUsers: 'roles/getInvitedUsers',
        getUsers: 'roles/getUsers',
        getOwnedRoles: 'roles/getOwnedRoles',
        getOwnedThings: 'things/getDevices'
      })
    },
    beforeRouteEnter(to, from, next) {
      next(async vm => {
        vm.showLoader()
        await vm.getInvitedUsers(vm.token);
        await vm.getUsers(vm.token);
        await vm.getOwnedRoles({token: vm.token, id: ''});
        await vm.getOwnedThings({token: vm.token, id: ''});
        vm.hideLoader()
        vm.setFullSidebar(true);
        vm.setRouteName('')
        vm.setShowInfo(false)
      })
    },
    beforeRouteLeave(to, from, next) {
      this.setRightInfo('');
      next();
    }
  }
</script>

<style lang="scss" scoped>
.users-page {
  display: flex;
}

</style>

